import React, { useEffect, useState, useLocation } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FiltroReporteRecuperacionCartera } from "./FiltroReporteRecuperacionCartera";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";

export const ReporteRecuperacionCartera = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const onHome = () => {
    history.push("/Creditoycobranza/Main");
  };
  const [data, setData] = useState([]);
  const [fechainicio, setFechaInicio] = useState("");
  const [fechafinal, setFechaFinal] = useState("");
  useEffect(() => {
    // onCargarRecuperacion();
  }, []);
  const onCargarReporteRecuperacion = ({ fechainicio, fechafinal }) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      const obj = {
        fechainicio: fechainicio,
        fechafinal: fechafinal,
      };
      setFechaInicio(fechainicio);
      setFechaFinal(fechafinal);
      request
        .post(
          `ReporteRecuperacionCartera/ObtenerReporteRecuperacionCartera`,
          obj
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
          //   Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
        });
    });
  };
  const onGeneraExcel = (fechainicio, fechafinal) => {
    setLoader({ ...loader, mostrar: true });
    const obj = {
      fechainicio: fechainicio,
      fechafinal: fechafinal,
    };
    request
      .post("ReporteRecuperacionCartera/GenerarExcel", obj)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("COBRANZA", "Error al generar el archivo Excel", "error");
      });
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  return (
    <PlantillaScreen
      titulo={"REPORTE DE RECUPERACION DE CARTERA"}
      className_main={1}
      className={"reporte-recuperacion-cartera"}
    >
      <LoaderScreen loader={loader} />
      <FiltroReporteRecuperacionCartera
        onCargarReporteRecuperacion={onCargarReporteRecuperacion}
      />

      <button
        className="excel"
        onClick={(e) => onGeneraExcel(fechainicio, fechafinal)}
      >
        <i className=" icon-file-excel" /> Excel
      </button>

      {data === undefined || data === null || data.length === 0 ? (
        <div></div>
      ) : (
        <div className="recuperacion-cartera-container-table scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Sucursal</th>
                <th>
                  <div>Cod. Cliente</div>
                </th>
                <th>
                  <div>Razón Social</div>
                </th>
                <th>
                  <div>Factura</div>
                </th>
                <th>
                  <div>Importe</div>
                </th>
                <th>
                  <div>Pago</div>
                </th>
                <th>
                  <div>Fecha</div>
                </th>
                <th>
                  <div>Fecha de Pago</div>
                </th>
                <th>
                  <div>Días</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <td>{capitalizeWords(item.sucursal)}</td>
                  <td>{item.codigocliente}</td>
                  <td>{capitalizeWords(item.razonsocial)}</td>
                  <td>{item.factura}</td>
                  <td>{FormatMoney(item.importe)}</td>
                  <td>{FormatMoney(item.pago)}</td>
                  <td>{item.fecha.split("T")[0]}</td>{" "}
                  <td>{item.fechapago.split("T")[0]}</td> <td>{item.dias}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="home" onClick={() => onHome()}>
        <ArrowBackIcon /> Regresar
      </div>
    </PlantillaScreen>
  );
};
